import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';

const loading = keyframes`
0% { clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0% 100%); }
5% { clip-path: polygon(0 75%, 100% 75%, 100% 100%, 0% 100%); }
35% { clip-path: polygon(0 20%, 100% 20%, 100% 100%, 0 100%); }
50% { clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%); }
55% { clip-path: polygon(0 0, 100% 0, 100% 75%, 0 75%); }
80% { clip-path: polygon(0 0, 100% 0, 100% 20%, 0% 20%); }
100% { clip-path: polygon(0 0, 100% 0, 100% 0, 0% 0%); }
`;
export const Img = styled('img')(({ width, height }) => ({
  width: width || '48px',
  height: height || '56px',
  position: 'absolute',
}));
export const ImgLoading = styled('img')(({ width, height }) => ({
  position: 'absolute',
  width: width || '48px',
  height: height || '56px',
  clipPath: 'polygon(0 100%, 100% 100%, 100% 100%, 0% 100%)',
  animation: `${loading} 5000ms infinite ease`,
}));
